import { t } from "i18next";

export const bundles = {
  lueur: {
    id: "lueur", // clé logique pour l'API
    monthlyPrice: 44.99,
    pricing: [
      { duration: 3, finalPrice: 134.97, reach: "local" },
      { duration: 6, finalPrice: 269.94, reach: "local" },
      { duration: 12, finalPrice: 539.88, reach: "local" },
    ],
    image:
      "https://ldgsoggxiujexptwxyar.supabase.co/storage/v1/object/public/makeadream-images/concert-5878452_1280.jpg",
    options: [
      "Votre image en première ligne sur nos visuels, réseaux sociaux et page d’accueil.",
      "Faites rayonner votre entreprise ou votre art dans notre espace « Partenaires ».",
      "Accès à la boutique en ligne pour proposer vos produits et services.",
      "BONUS (abonnement annuel) : Affiche promotionnelle",
    ],
  },

  ascension: {
    id: "ascension",
    monthlyPrice: 84.99,
    pricing: [
      { duration: 3, finalPrice: 254.97, reach: "local" },
      { duration: 6, finalPrice: 509.94, reach: "local" },
      { duration: 12, finalPrice: 1019.88, reach: "local" },

      { duration: 3, finalPrice: 374.97, reach: "regional" },
      { duration: 6, finalPrice: 749.94, reach: "regional" },
      { duration: 12, finalPrice: 1499.88, reach: "regional" },

      { duration: 3, finalPrice: 554.97, reach: "provincial" },
      { duration: 6, finalPrice: 1109.94, reach: "provincial" },
      { duration: 12, finalPrice: 2219.88, reach: "provincial" },
    ],
    image:
      "https://ldgsoggxiujexptwxyar.supabase.co/storage/v1/object/public/makeadream-images/advanced.jpg",
    options: [
      "Votre image en première ligne sur nos visuels, réseaux sociaux et page d’accueil.",
      "Faites rayonner votre entreprise ou votre art dans notre espace « Partenaires ».",
      "Accès à la boutique en ligne pour proposer vos produits et services.",
      "5 photos remises pour la promotion.",
      "BONUS (abonnement annuel) : Nouvelle prise de photos après 6 mois.",
    ],
  },

  impact: {
    id: "impact",
    monthlyPrice: 154.99,
    pricing: [
      {
        duration: 6,
        finalPrice: 929.94,
        reach: "local",
      },
      {
        duration: 12,
        finalPrice: 1766.89, // 1996.54 - 5%
        originalPrice: 1766.89 / 0.95, // ≈ 1865.15
        reach: "local",
      },

      {
        duration: 6,
        finalPrice: 1169.94,
        reach: "regional",
      },
      {
        duration: 12,
        finalPrice: 2222.89, // 2339.88 - 5%
        originalPrice: 2222.89 / 0.95, // ≈ 2340.94
        reach: "regional",
      },

      {
        duration: 6,
        finalPrice: 1529.94,
        reach: "provincial",
      },
      {
        duration: 12,
        finalPrice: 2906.89, // 3059.88 - 5%
        originalPrice: 2906.89 / 0.95, // ≈ 3059.88
        reach: "provincial",
      },
    ],
    image:
      "https://ldgsoggxiujexptwxyar.supabase.co/storage/v1/object/public/makeadream-images/premium.jpg",
    options: [
      "Votre image en première ligne sur nos visuels, réseaux sociaux et page d’accueil.",
      "Faites rayonner votre entreprise ou votre art dans notre espace « Partenaires ».",
      "Accès à la boutique en ligne et billetterie pour vos événements.",
      "10 photos remises pour la promotion.",
      "1 vidéo remise pour la promotion.",
      "Nouvelle prise de photos après 3 mois.",
      "Consultation stratégique (questionnaire et analyse de base).",
      "Montage photo pour publicité collective.",
      "BONUS (abonnement annuel) : 1 vidéo remise pour la promotion.",
    ],
    isHighlighted: true,
  },

  rayonnement: {
    id: "rayonnement",
    monthlyPrice: 224.99,
    pricing: [
      {
        duration: 6,
        finalPrice: 1349.94,
        reach: "local",
      },
      {
        duration: 12,
        finalPrice: 2429.89, // 2699.88 - 10%
        originalPrice: 2429.89 / 0.9, // ≈ 2699.88
        reach: "local",
      },

      {
        duration: 6,
        finalPrice: 1589.94,
        reach: "regional",
      },
      {
        duration: 12,
        finalPrice: 2861.89, // 3179.88 - 10%
        originalPrice: 2861.89 / 0.9, // ≈ 3179.88
        reach: "regional",
      },

      {
        duration: 6,
        finalPrice: 2549.94,
        reach: "provincial",
      },
      {
        duration: 12,
        finalPrice: 4589.89, // 5099.88 - 10%
        originalPrice: 4589.89 / 0.9, // ≈ 5099.88
        reach: "provincial",
      },
    ],
    image:
      "https://ldgsoggxiujexptwxyar.supabase.co/storage/v1/object/public/makeadream-images/community.jpg",
    options: [
      "Votre image en première ligne sur nos visuels, réseaux sociaux et page d’accueil.",
      "Faites rayonner votre entreprise ou votre art dans notre espace « Partenaires ».",
      "Accès à la boutique en ligne pour proposer vos produits et services.",
      "Accès au service de billetterie pour vos événements.",
      "10 à 15 photos remises pour la promotion.",
      "2 vidéos remises pour la promotion.",
      "Nouvelle série de photos ou vidéos après 3 mois.",
      "Consultation stratégique (questionnaire et analyse de base et en suivi).",
      "Montage photo et vidéo publicitaire collective et personnalisée.",
      "Possibilité d’obtenir une paire de billets pour participer à nos événements, selon la disponibilité.",
      "BONUS (abonnement annuel) : Entrevue publicitaire.",
    ],
  },
};
